module.exports = __webpack_public_path__ + "img/795cb8d.jpg";